// Libs
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import HTML from 'react-pdf-html';
// Interface
import { formatPrice } from '~/utils/helper';
import { PropsType } from './documentPDF.interface';
import { MAX_DISCOUNT, UNICODE_EURO } from '~/utils/constants';

export const DocumentPDF = (props: PropsType) => {
  const { data, dataTable, dateTimePDF } = props;

  const { t } = useTranslation();

  const styles = StyleSheet.create({
    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },

    tableTitle: {
      fontSize: 8,
      fontStyle: 'bold',
      paddingTop: 4,
      paddingLeft: 7,
      flex: 1,
      height: 20,
      backgroundColor: '#F6F8FA',
      borderColor: 'whitesmoke',
      borderRightWidth: 1,
      borderBottomWidth: 1,
    },

    tableTitle2: { flex: 2, borderRightWidth: 0, borderBottomWidth: 1 },

    tbody: { fontSize: 6, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'whitesmoke', borderRightWidth: 1, borderBottomWidth: 1 },

    tbody2: { flex: 2, borderRightWidth: 1 },

    container: {
      flexDirection: 'column',
      padding: 10,
      flex: 1,
    },
    textTitle: {
      padding: 10,
    },
    title: {
      fontSize: 15,
      backgroundColor: '#F6F8FA',
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
    },
    titleCart: {
      fontSize: 15,
      padding: 10,
      backgroundColor: '#F6F8FA',
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
    },
    titleInfo: {
      fontSize: 6,
      fontWeight: 'bold',
      marginBottom: 5,
    },
    contentInfo: {
      fontSize: 8,
      marginBottom: 10,
      marginRight: 20,
      fontWeight: 'thin',
    },
    detailInfoRow: {
      width: 150,
    },
    column: {
      flexDirection: 'row',
      padding: 10,
    },
    contentOrder: {
      border: '1px solid #EEE',
      padding: 10,
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
    row: {
      flexDirection: 'row',
    },

    productData: {
      border: '1px solid #EEE',
      padding: 5,
      borderRadius: 5,
    },
    contentOrderFlex: {
      flex: 1,
    },
    priceTotal: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 5,
      fontSize: 13,
      borderTop: '1px solid #EEE',
      backgroundColor: '#F6F8FA',
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
  });

  const InvoiceTitle = () => (
    <View style={styles.title}>
      <Text style={styles.textTitle}>
        {t('orders_details_title', {
          orderId: dateTimePDF.orderId,
          dateString: dateTimePDF.dateString,
          timeString: dateTimePDF.timeString,
        })}
      </Text>
    </View>
  );

  const Address = () =>
    data && (
      <View style={styles.column}>
        <View>
          <View style={styles.row}>
            <View>
              <Text style={styles.titleInfo}>{t('orders_details_clientCode')}</Text>
              <Text style={styles.contentInfo}>{data.clientCode}</Text>
            </View>
            <View>
              <Text style={styles.titleInfo}>{t('orders_details_listN')}</Text>
              <Text style={styles.contentInfo}>{data.listingCode}</Text>
            </View>
          </View>
          <View>
            <Text style={styles.titleInfo}>{t('orders_details_clientName')}</Text>
            <Text style={styles.contentInfo}>{data.name}</Text>
          </View>
          <View>
            <Text style={styles.titleInfo}>{t('clients_clientDetails_newOrder_email')}</Text>
            <Text style={styles.contentInfo}>{data.email}</Text>
          </View>
          <View>
            <Text style={styles.titleInfo}>{t('clients_clientDetails_newOrder_phone')}</Text>
            <Text style={styles.contentInfo}>{data.phone}</Text>
          </View>
          <View>
            <Text style={styles.titleInfo}>{t('orders_details_paymentType')}</Text>
            <Text style={styles.contentInfo}>{data.paymentName}</Text>
          </View>
        </View>
        <View style={styles.contentOrderFlex}>
          <View style={styles.detailInfoRow}>
            <Text style={styles.titleInfo}>{t('orders_details_clientAddress')}</Text>
            <Text style={styles.contentInfo}>{data.address}</Text>
          </View>
          <View style={styles.row}>
            <View style={styles.detailInfoRow}>
              <Text style={styles.titleInfo}>{t('orders_details_zipCode')}</Text>
              <Text style={styles.contentInfo}>{data.zipCode}</Text>
            </View>
            <View style={styles.detailInfoRow}>
              <Text style={styles.titleInfo}>{t('orders_details_city')}</Text>
              <Text style={styles.contentInfo}>{data.city}</Text>
            </View>
            <View style={styles.detailInfoRow}>
              <Text style={styles.titleInfo}>{t('orders_details_province')}</Text>
              <Text style={styles.contentInfo}>{data.province}</Text>
            </View>
          </View>
          <View>
            <Text style={styles.titleInfo}>{t('orders_details_vatNumber')}</Text>
            <Text style={styles.contentInfo}>{data.vatNumber}</Text>
          </View>
          <View style={styles.detailInfoRow}>
            <Text style={styles.titleInfo}>{t('orders_details_codiceFiscale')}</Text>
            <Text style={styles.contentInfo}>{data.healthCode}</Text>
          </View>
          {data.note && (
            <View style={styles.detailInfoRow}>
              <Text style={styles.titleInfo}>{t('orders_details_orderNote')}</Text>
              <Text style={styles.contentInfo}>{data.note}</Text>
            </View>
          )}
        </View>
      </View>
    );

  const TableHead = () => (
    <View style={{ width: '100%', flexDirection: 'row' }}>
      <View style={{ width: '15%' }}>
        <View style={styles.tableTitle}>
          <Text>{t('orders_orderDetail_cart_table_id')}</Text>
        </View>
      </View>
      <View style={{ width: '45%' }}>
        <View style={[styles.tableTitle, styles.tableTitle2]}>
          <Text>{t('orders_orderDetail_cart_table_productName')}</Text>
        </View>
      </View>

      <View style={styles.tableTitle}>
        <Text>{t(`${t('orders_orderDetail_cart_table_price')} (${UNICODE_EURO})`)}</Text>
      </View>

      <View style={styles.tableTitle}>
        <Text>{t('orders_orderDetail_cart_table_discount')}</Text>
      </View>

      <View style={styles.tableTitle}>
        <Text>{t('orders_orderDetail_cart_table_quantity')}</Text>
      </View>

      <View style={styles.tableTitle}>
        <Text>{t(`${t('orders_orderDetail_cart_table_total')} (${UNICODE_EURO})`)}</Text>
      </View>
    </View>
  );

  const TableBody = () => (
    <>
      {dataTable?.map((item) => (
        <View key={item.id} style={{ width: '100%', flexDirection: 'row' }}>
          <View style={{ width: '15%' }}>
            <View style={styles.tbody}>
              <Text>{item.productCode}</Text>
            </View>
          </View>
          <View style={{ width: '45%' }}>
            <View style={[styles.tbody, styles.tbody2]}>
              <Text>{item.productName}</Text>
            </View>
          </View>
          <View style={styles.tbody}>
            <Text>{formatPrice(item?.priceProduct, false)} </Text>
          </View>
          <View style={styles.tbody}>
            <Text>{item.discount === MAX_DISCOUNT ? MAX_DISCOUNT : `${item.discount} %`}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{item.quantity}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{formatPrice(item?.totalPrice, false)}</Text>
          </View>
        </View>
      ))}
    </>
  );

  const TableTotal = () => (
    <View style={styles.priceTotal}>
      <Text>{t('orders_orderDetail_cart_table_total')}</Text>
      <Text>{formatPrice(data.total)}</Text>
    </View>
  );

  const htmlString = `
  <div style="padding: 10px;">
    <div style="font-size: 15px; background-color: #F6F8FA; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;">
      <strong>${t('orders_details_title', {
        orderId: dateTimePDF.orderId,
        dateString: dateTimePDF.dateString,
        timeString: dateTimePDF.timeString,
      })}</strong>
    </div>

    <div style="border: 1px solid #EEE; padding: 10px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
      <div style="padding: 10px; display: flex; flex-direction: row;">
        <div>
          <div style="display: flex; flex-direction: row;">
            <div>
              <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_clientCode')}</p>
              <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.clientCode}</p>
            </div>
            <div>
              <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_listN')}</p>
              <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.listingCode}</p>
            </div>
          </div>
           <div>
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_clientName')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.name}</p>
          </div>
           <div>
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('clients_clientDetails_newOrder_email')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.email}</p>
          </div>
          <div>
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('clients_clientDetails_newOrder_phone')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.phone}</p>
          </div>
          <div>
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_paymentType')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.paymentName}</p>
          </div>
        </div>
  
        <div style="flex: 1;">
          <div style="width: 150px;">
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_clientAddress')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.address}</p>
          </div>
          <div style="display: flex; flex-direction: row;">
             <div style="width: 150px;">
              <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_zipCode')}</p>
              <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.zipCode}</p>
            </div>
            <div style="width: 150px;">
              <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_city')}</p>
              <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.city}</p>
            </div>
            <div style="width: 150px;">
              <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_province')}</p>
              <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.province}</p>
            </div>
          </div>
          <div style="width: 150px;">
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_vatNumber')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.vatNumber}</p>
          </div>
          <div style="width: 150px;">
            <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_codiceFiscale')}</p>
            <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.healthCode}</p>
          </div>
          ${
            data.note
              ? `<div style="width: 150px;">
                   <p style="font-size: 6px; font-weight: bold; margin: 0; margin-bottom: 5px;">${t('orders_details_orderNote')}</p>
                   <p style="font-size: 8px; margin: 0; margin-bottom: 10px; margin-right: 20px; font-weight: 100;">${data.note}</p>
                </div>`
              : `<div></div>`
          }
        </div>
      </div>

      ${
        data.adminNote
          ? `
        <div style="padding-left: 10px; padding-right: 10px;">
            ${data.adminNote}
        </div>
        `
          : `<div></div>`
      }

      <div style="border: 1px solid #EEE; padding: 5px; border-radius: 5px;">
        <h3 style="margin: 0; font-size: 15px; padding: 10px; background-color: #F6F8FA; border-top-left-radius: 5px; border-top-right-radius: 5px;">
          ${t('orders_details_cart_title')}
        </h3>

        <table style="width: 100%; border-collapse: collapse; margin: 0;">
          <thead>
            <tr style="background-color: #F6F8FA; font-size: 8px; font-weight: bold;">
              <th style="width: 15%; padding: 5px;">${t('orders_orderDetail_cart_table_id')}</th>
               <th style="width: 45%; padding: 5px;">${t('orders_orderDetail_cart_table_productName')}</th>
               <th style="width: 10%; padding: 5px;">${t('orders_orderDetail_cart_table_price')} (€)</th>
               <th style="width: 10%; padding: 5px;">${t('orders_orderDetail_cart_table_discount')}</th>
               <th style="width: 10%; padding: 5px;">${t('orders_orderDetail_cart_table_quantity')}</th>
               <th style="width: 10%; padding: 5px;">${t('orders_orderDetail_cart_table_total')} (€)</th>
             </tr>
           </thead>
           <tbody>
             ${dataTable
               ?.map(
                 (item) => `
               <tr style="border: 1px solid #EEE; font-size: 6px;">
                <td style="width: 15%; padding: 5px; border-right: 1px solid #EEE;">${item.productCode}</td>
                <td style="width: 45%; padding: 5px; border-right: 1px solid #EEE;">${item.productName}</td>
                <td style="width: 10%; padding: 5px; border-right: 1px solid #EEE;">${formatPrice(item?.priceProduct, false)}</td>
                <td style="width: 10%; padding: 5px; border-right: 1px solid #EEE;">${item.discount === MAX_DISCOUNT ? MAX_DISCOUNT : `${item.discount} %`}</td>
                <td style="width: 10%; padding: 5px; border-right: 1px solid #EEE;">${item.quantity}</td>
                <td style="width: 10%; padding: 5px;">${formatPrice(item?.totalPrice, false)}</td>
              </tr>`
               )
               .join('')}
          </tbody>
         </table>

         <div style="display: flex; flex-direction: row; justify-content: space-between; font-size: 13px; padding: 5px; border-top: 1px solid #EEE; background-color: #F6F8FA; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
           <p style="font-size: 14px; margin: 0;">${t('orders_orderDetail_cart_table_total')}</p>
           <p style="font-size: 14px; margin: 0;">${formatPrice(data.total)}</p>
         </div>
       </div>
    </div>
  </div>
`;

  return (
    // <Document>
    //   <Page size='A4' style={styles.page}>
    //     <View style={styles.container}>
    //       <InvoiceTitle />
    //       <View style={styles.contentOrder}>
    //         <Address />
    //         {adminNoteImage && <Image src={adminNoteImage} />}
    //         <View style={styles.productData}>
    //           <Text style={styles.titleCart}>{t('orders_details_cart_title')}</Text>
    //           <TableHead />
    //           <TableBody />
    //           <TableTotal />
    //         </View>
    //       </View>
    //     </View>
    //   </Page>
    // </Document>

    <Document>
      <Page size='A4' style={styles.page}>
        <View>
          <HTML>{htmlString}</HTML>
        </View>
      </Page>
    </Document>
  );
};
